import MarketingdashboardAside from "./MarketingdashboardAside";
import Marketingdashboard from "./Marketing_dashboard";
import './layouts.css'


function MarketingDashboardlayout() {

    return (
        <div className="layout">

            <MarketingdashboardAside className="asideBar" />
            <Marketingdashboard className='mainBlock' />


        </div>
    )
}
export default MarketingDashboardlayout;